import { createContext } from "react";
import type { ConsentState } from "../../lib/storage";

export interface ConsentContextValue {
  /** Current consent state */
  consent: ConsentState;
  /** Accept analytics cookies */
  accept: () => void;
  /** Reject analytics cookies */
  reject: () => void;
}

export const ConsentContext = createContext<ConsentContextValue | undefined>(undefined);
